import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  text-align: center;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " ", "s infinite linear;\n  border: ", "px solid ", ";\n  border-left: ", "px solid ", ";\n  border-radius: 50%;\n  height: ", "px;\n  margin-left: -", "px;\n  margin-top: -", "px;\n  ", "\n\n  transform: translateZ(0);\n  width: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { position, rgba } from 'polished';
import { color } from '@scp/ui-shared/theme/variables';
import { Subtext } from '@scp/ui-shared/components/typography';
export var DURATION = 1.4;
export var spinAnimation = keyframes(_templateObject());
var Spinner = styled.span(_templateObject2(), spinAnimation, DURATION, function (props) {
  return props.size / 9;
}, rgba(color.backgroundDark, 0.2), function (props) {
  return props.size / 9;
}, color.backgroundDark, function (props) {
  return props.size;
}, function (props) {
  return props.size / 2 + props.size / 9;
}, function (props) {
  return props.size / 2 + props.size / 9;
}, position('absolute', '50%', '50%'), function (props) {
  return props.size;
});
var Label = styled(Subtext)(_templateObject3(), function (props) {
  return props.size / 2 + 12;
}, position('absolute', '50%', '0', '50%'));
/**
 * A generic loader component.
 * It's absolutely-positioned, so make sure that container has `position: relative`.
 *
 * Can be used a root-level loader or a local one (for example it can be inside a sidebar).
 *
 * @example ./__docs__/Loader.md
 */

export function Loader(_ref) {
  var label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 54 : _ref$size;
  return React.createElement(React.Fragment, null, React.createElement(Spinner, {
    size: size
  }), label && React.createElement(Label, {
    size: size
  }, label));
}